import { createSlice } from '@reduxjs/toolkit';

export const versionsSlice = createSlice({
  name: "versions",
  initialState: {
    selectedVersions: {},
    freeze: null
  },
  reducers: {
    set: (state, action) => {
      Object.keys((action.payload)).map((key) => state.selectedVersions[key] = action.payload[key]);
      return state;
    },
    freeze: (state, action) => {
      state.freeze = action.payload;
      return state;
    }
  }
});

export const { set: setSelectedVersions, freeze: freezeVersion } = versionsSlice.actions;
export default versionsSlice.reducer;
